export interface RankingBadgeProps {
	statusText: string;
	showBadge?: boolean;
	isProPlayer?: boolean;
	badgeCenterClass?: string;
	borderColorClass?: string;
	bgColorClass?: string;
	textColorClass?: string;
	size: 'base' | 'sm';
	year?: number;
}

export interface RankingBadgeParams {
	rankingStatus: RankingStatusBadgeEnum | undefined;
	showBadge: boolean | undefined;
	badgeRank?: number;
	badgeCenter?: boolean;
	borderColorClass?: string;
	bgColorClass?: string;
	textColorClass?: string;
	size?: 'base' | 'sm';
	year?: number;
}

export enum RankingStatusBadgeEnum {
	TOUR_PRO = 'TOUR PRO',
	LEGEND = 'LEGEND',
	ICON = 'ICON',
	TITAN = 'TITAN',
	BALLER = 'BALLER',
	CONTENDER = 'CONTENDER',
	PLAYER = 'PLAYER',
	TOP_1 = 'Top 1',
	TOP_50 = 'Top 50',
	TOP_100 = 'Top 100',
	TOP_500 = 'Top 500',
	TOP_1000 = 'Top 1000',
	DEFAULT = ''
}

export const RankingBadgeStatusText: Record<RankingStatusBadgeEnum, string> = {
	[RankingStatusBadgeEnum.TOUR_PRO]: '',
	[RankingStatusBadgeEnum.LEGEND]: 'Legend',
	[RankingStatusBadgeEnum.ICON]: 'Icon',
	[RankingStatusBadgeEnum.TITAN]: 'Titan',
	[RankingStatusBadgeEnum.BALLER]: 'Baller',
	[RankingStatusBadgeEnum.CONTENDER]: 'Contender',
	[RankingStatusBadgeEnum.PLAYER]: 'Player',
	[RankingStatusBadgeEnum.TOP_1]: 'Top 1',
	[RankingStatusBadgeEnum.TOP_50]: 'Top 50',
	[RankingStatusBadgeEnum.TOP_100]: 'Top 100',
	[RankingStatusBadgeEnum.TOP_500]: 'Top 500',
	[RankingStatusBadgeEnum.TOP_1000]: 'Top 1000',
	[RankingStatusBadgeEnum.DEFAULT]: ''
};
